import DOMPurify from "dompurify"

export const reloadFrame = (frameId) => {
  const turboFrame = document.getElementById(frameId)

  if (!turboFrame) {
    console.log(`Do not see frame ${frameId} on the page. Skip reloading`)
    return
  }

  const url = turboFrame.dataset.url

  if (!url) {
    console.error("No URL specified in data-url attribute of the frame.")
    return
  }

  fetch(url, {
    headers: {
      Accept: "text/vnd.turbo-stream.html",
      "X-Requested-With": "reload-frame"
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("Failed to fetch dialogs list")
      }
      return response.text()
    })
    .then(html => {
      turboFrame.innerHTML = DOMPurify.sanitize(html)
    })
    .catch(error => {
      console.error("Error updating dialogs list:", error)
    })
}
